
const FaqAccordion = (props) => {
  const { faq, activeFaq, setActiveFaq } = props;

  return (
    <li className={`relative border mb-3 rounded-xl ${activeFaq === faq?.id ? "bg-primary text-white" : "bg-white text-black border-lightGray"}`}>
      <button type="button" className="w-full md:px-6 px-3 md:py-4 py-2.5 text-left" onClick={() => setActiveFaq((prev) => prev == faq?.id ? "" : faq?.id)}>
        <div className="flex items-center justify-between">
          <span className="md:text-base text-sm leading-normal font-medium">
            {faq.questions}
          </span>
          <svg className={`w-5 h-5 transform ${activeFaq === faq?.id ? "rotate-180" : ""}`} fill="none" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" viewBox="0 0 24 24" stroke={activeFaq === faq?.id ? "#fff" : "#000"}>
            <path d="M19 9l-7 7-7-7"></path>
          </svg>
        </div>
      </button>
      <div className={`relative overflow-hidden ${activeFaq === faq?.id ? "max-h-screen" : "max-h-0"} transition-all`}>
        <div className="md:px-6 px-3 md:py-4 py-2.5">
          <p className="md:text-sm text-xs leading-normal font-normal text-white">{faq?.answers}</p>
        </div>
      </div>
    </li>
  );
}

export default FaqAccordion;
